exports = module.exports = require("../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".am-icon {\n  fill: currentColor;\n  background-size: cover;\n  width: 0.44rem;\n  height: 0.44rem;\n}\n.am-icon-xxs {\n  width: 0.3rem;\n  height: 0.3rem;\n}\n.am-icon-xs {\n  width: 0.36rem;\n  height: 0.36rem;\n}\n.am-icon-sm {\n  width: 0.42rem;\n  height: 0.42rem;\n}\n.am-icon-md {\n  width: 0.44rem;\n  height: 0.44rem;\n}\n.am-icon-lg {\n  width: 0.72rem;\n  height: 0.72rem;\n}\n.am-icon-loading {\n  -webkit-animation: cirle-anim 1s linear infinite;\n          animation: cirle-anim 1s linear infinite;\n}\n@-webkit-keyframes cirle-anim {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes cirle-anim {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#1DA57A"}}!./~/antd-mobile/lib/icon/style/index.less
// module id = 300
// module chunks = 0 1